// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

import { LatLng } from './LatLng';

import type { LatLngModelType } from 'common/models/flow/LatLng';

type ProviderEnum = 'CLIENT_READ' | 'CLIENT_GEOCODER' | 'LOCUS_GEOCODER';
type ConfidenceEnum = 'LOW' | 'MEDIUM' | 'HIGH';

export type GeometryModelType = {
    latLng: ?LatLngModelType,
    provider?: ?ProviderEnum,
    confidence?: ?ConfidenceEnum
};

export type LatLngLineSegmentsModelType = {
    segments: Array<LatLngLineSegmentModelType>
};

export type CompositeLatLngPolygonModelType = {
    polygons: Array<LatLngPolygonModelType>
};

export type LatLngPolygonModelType = {
    vertices: Array<LatLngModelType>
};

export type LatLngPolygonPointsModelType = {
    points: Array<LatLngModelType>
};

export type LatLngLineSegmentModelType = {
    latLng1: LatLngModelType,
    latLng2: LatLngModelType
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class Geometry extends ImmutableModel {
    static fromJS(json: GeometryModelType): Geometry {
        const state: Object = Object.assign({}, json);
        state.latLng = state.latLng
            ? LatLng.fromJS(state.latLng)
            : state.latLng;
        return new this(Immutable.Map(state));
    }

    toJS(): GeometryModelType {
        const js: GeometryModelType = {
            latLng: this.latLng ? this.latLng.toJS() : this.latLng
        };

        if (this.provider != null) {
            js.provider = this.provider;
        }

        if (this.confidence != null) {
            js.confidence = this.confidence;
        }

        return js;
    }

    get latLng(): ?LatLng {
        return this._state.get('latLng');
    }

    setLatLng(latLng: ?LatLng): this {
        return this.clone(this._state.set('latLng', latLng));
    }

    get provider(): ?ProviderEnum {
        return this._state.get('provider');
    }

    setProvider(provider: ?ProviderEnum): this {
        return this.clone(this._state.set('provider', provider));
    }

    get confidence(): ?ConfidenceEnum {
        return this._state.get('confidence');
    }

    setConfidence(confidence: ?ConfidenceEnum): this {
        return this.clone(this._state.set('confidence', confidence));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class LatLngLineSegments extends ImmutableModel {
    static fromJS(json: LatLngLineSegmentsModelType): LatLngLineSegments {
        const state: Object = Object.assign({}, json);
        state.segments = Immutable.List(state.segments).map(item =>
            LatLngLineSegment.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): LatLngLineSegmentsModelType {
        return {
            segments: this.segments.toArray().map(item => item.toJS())
        };
    }

    get segments(): Immutable.List<LatLngLineSegment> {
        return this._state.get('segments');
    }

    setSegments(segments: Immutable.List<LatLngLineSegment>): this {
        return this.clone(this._state.set('segments', segments));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class CompositeLatLngPolygon extends ImmutableModel {
    static fromJS(
        json: CompositeLatLngPolygonModelType
    ): CompositeLatLngPolygon {
        const state: Object = Object.assign({}, json);
        state.polygons = Immutable.List(state.polygons).map(item =>
            LatLngPolygon.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): CompositeLatLngPolygonModelType {
        return {
            polygons: this.polygons.toArray().map(item => item.toJS())
        };
    }

    get polygons(): Immutable.List<LatLngPolygon> {
        return this._state.get('polygons');
    }

    setPolygons(polygons: Immutable.List<LatLngPolygon>): this {
        return this.clone(this._state.set('polygons', polygons));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class LatLngPolygon extends ImmutableModel {
    static fromJS(json: LatLngPolygonModelType): LatLngPolygon {
        const state: Object = Object.assign({}, json);
        state.vertices = Immutable.List(state.vertices).map(item =>
            LatLng.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): LatLngPolygonModelType {
        return {
            vertices: this.vertices.toArray().map(item => item.toJS())
        };
    }

    get vertices(): Immutable.List<LatLng> {
        return this._state.get('vertices');
    }

    setVertices(vertices: Immutable.List<LatLng>): this {
        return this.clone(this._state.set('vertices', vertices));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class LatLngLineSegment extends ImmutableModel {
    static fromJS(json: LatLngLineSegmentModelType): LatLngLineSegment {
        const state: Object = Object.assign({}, json);
        state.latLng1 = LatLng.fromJS(state.latLng1);
        state.latLng2 = LatLng.fromJS(state.latLng2);
        return new this(Immutable.Map(state));
    }

    toJS(): LatLngLineSegmentModelType {
        return {
            latLng1: this.latLng1.toJS(),
            latLng2: this.latLng2.toJS()
        };
    }

    get latLng1(): LatLng {
        return this._state.get('latLng1');
    }

    setLatLng1(latLng1: LatLng): this {
        return this.clone(this._state.set('latLng1', latLng1));
    }

    get latLng2(): LatLng {
        return this._state.get('latLng2');
    }

    setLatLng2(latLng2: LatLng): this {
        return this.clone(this._state.set('latLng2', latLng2));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class LatLngPolygonPoints extends ImmutableModel {
    static fromJS(json: LatLngPolygonPointsModelType): LatLngPolygonPoints {
        const state: Object = Object.assign({}, json);
        state.points = Immutable.List(state.points).map(item =>
            LatLng.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): LatLngPolygonPointsModelType {
        return {
            points: this.points.toArray().map(item => item.toJS())
        };
    }

    get points(): Immutable.List<LatLng> {
        return this._state.get('points');
    }

    setPoints(points: Immutable.List<LatLng>): this {
        return this.clone(this._state.set('points', points));
    }
}
